if (!customElements.get('lac-lightwrap-buy')) {
  customElements.define('lac-lightwrap-buy', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.form = this.querySelector('product-form form');
      this.button = this.querySelector('[type="submit"]');
      this.error = this.querySelector('[data-buy-error]');
      this.selects = [...this.querySelectorAll('[data-buy-option]')];
      this.querySelector('[data-buy-controls]').hidden = false;
      this.addEventListener('change', event => {
        if (event.target.matches('[data-buy-option]')) this.updateVariant();
      }, { signal: this.abort.signal });
      this.addEventListener('click', event => {
        const thumbnail = event.target.closest('[data-buy-thumbnail]');
        if (!thumbnail || !this.contains(thumbnail) || thumbnail.getAttribute('aria-pressed') === 'true') return;
        const image = thumbnail.querySelector('template').content.querySelector('img');
        if (image) this.querySelector('[data-buy-media]').replaceChildren(image.cloneNode(true));
        this.querySelectorAll('[data-buy-thumbnail]').forEach(button => button.setAttribute('aria-pressed', String(button === thumbnail)));
      }, { signal: this.abort.signal });
      this.closest('.lw').querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.href, location.origin);
        if (url.origin === location.origin && url.pathname === this.dataset.url && !url.searchParams.has('variant') && !url.hash) link.setAttribute('href', '#' + this.id);
      });
    }
    async updateVariant() {
      this.request?.abort();
      if (this.selects.some(select => !select.value)) {
        this.form.elements.id.value = '';
        this.button.disabled = true;
        this.button.setAttribute('aria-disabled', 'true');
        this.removeAttribute('aria-busy');
        const url = new URL(location.href); url.searchParams.delete('variant'); history.replaceState({}, '', url);
        return;
      }
      this.request = new AbortController();
      const request = this.request;
      this.error.hidden = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-disabled', 'true');
      this.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(this.dataset.url, location.origin);
        url.searchParams.set('section_id', 'lac-lightwrap-buy-state');
        url.searchParams.set('option_values', this.selects.map(select => select.value).join(','));
        const previewId = new URLSearchParams(location.search).get('preview_theme_id');
        if (previewId) url.searchParams.set('preview_theme_id', previewId);
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('Variant request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const state = doc.querySelector('[data-buy-state]');
        if (!state) throw new Error('Variant response missing');
        if (request.signal.aborted || this.request !== request) return;
        this.querySelector('[data-buy-status]').replaceChildren(state);
        this.form.elements.id.value = state.dataset.id || '';
        const address = new URL(location.href);
        if (state.dataset.id) address.searchParams.set('variant', state.dataset.id); else address.searchParams.delete('variant');
        history.replaceState({}, '', address);
        const termsInput = this.querySelector('[data-buy-terms-id]');
        termsInput.value = state.dataset.id || '';
        termsInput.dispatchEvent(new Event('change', { bubbles: true }));
        const sku = this.querySelector('[data-buy-sku]');
        sku.hidden = !state.dataset.sku;
        sku.querySelector('span').textContent = state.dataset.sku || '';
        const available = state.dataset.available === 'true' && !!state.dataset.id;
        this.button.disabled = !available;
        this.button.setAttribute('aria-disabled', String(!available));
        this.querySelector('[data-buy-button-text]').textContent = available ? this.dataset.add : (state.dataset.id ? this.dataset.sold : this.dataset.unavailable);
        const quantity = this.form.elements.quantity;
        const min = Number(state.dataset.min) || 1;
        const step = Number(state.dataset.step) || 1;
        quantity.min = min;
        quantity.step = step;
        if (state.dataset.max) quantity.max = state.dataset.max; else quantity.removeAttribute('max');
        let value = Math.max(min, Number(quantity.value) || min);
        value = min + Math.ceil((value - min) / step) * step;
        if (state.dataset.max) value = Math.min(value, Number(state.dataset.max));
        quantity.value = value;
        const image = state.querySelector('template[data-buy-image]').content.querySelector('img');
        if (image) this.querySelector('[data-buy-media]').replaceChildren(image.cloneNode(true));
        if (image) this.querySelectorAll('[data-buy-thumbnail]').forEach(button => {
          const thumbImage = button.querySelector('template').content.querySelector('img');
          button.setAttribute('aria-pressed', String(new URL(thumbImage.src, location.origin).pathname === new URL(image.src, location.origin).pathname));
        });
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
        this.querySelector('product-form').handleErrorMessage?.();
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.error.textContent = this.dataset.error;
          this.error.hidden = false;
        }
      } finally {
        if (this.request === request) this.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() { this.abort?.abort(); this.request?.abort(); }
  });
}

